import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DFAdmin, DFChargeList, DFCountryVariableCharges } from 'app/df-management/shared/df-management-admin-data.modal';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import {  MasterData } from 'app/df-management/shared/df-master-data.model';
import { DataTableColumn, DataTableComponent } from 'app/shared/data-table/data-table.component';
import { LoaderService } from 'app/shared/services/loader.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { SearchObjectResult } from 'app/shared/search-object-result.model';
import { SortDirection } from 'app/shared/sort-direction';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-df-variable-charges',
  templateUrl: './df-variable-charges.component.html',
  styleUrls: ['./df-variable-charges.component.scss']
})
export class DfVariableChargesComponent implements OnInit {
  variableChargesDataForm: FormGroup;
  isVisible = false;
  editChargesData: DFAdmin;
  countryCode: string;
  countryList: DFAdmin[]
  variableChargesList: any[] = [];
  isEditMode = false;
  isPopupModel = false;
  isShowChargeList = false;
  variableChargeAdded = false;
  searchText: string;
  @ViewChild('countryNameColumn', { static: true })
  countryNameColumn: TemplateRef<any>;

  @ViewChild('countryCodeColumn', { static: true })
  countryCodeColumn: TemplateRef<any>;

  @ViewChild('createdOnColumn', { static: true })
  createdOnColumn: TemplateRef<any>;

  @ViewChild('timeZoneColumn', { static: true })
  timeZoneColumn: TemplateRef<any>;

  @ViewChild('fixedChargesFrequencyColumn', { static: true })
  fixedChargesFrequencyColumn: TemplateRef<any>;

  @ViewChild('variableChargesColumn', { static: true })
  variableChargesColumn: TemplateRef<any>;

  @ViewChild('actionsColumn', { static: true })
  actionsColumn: TemplateRef<any>;

  @ViewChild(DataTableComponent, { static : true })
  adminListTable: DataTableComponent;
  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  SortDirection = SortDirection.ASC;
  filters: any = {};
  loadPage: (...config) => Observable<SearchObjectResult<MasterData>> = null;
  constructor(private fb: FormBuilder, private dfManagementService: DfManagementService,
    public navigationService: NavigationService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private translate: TranslateService) {
   }

  ngOnInit(): void {
    this.variableChargesDataForm = this.fb.group({
      countryCode: [''],
      countryName: [''],
      timezone: [''],
      variableChargeName: ['', Validators.required],
      description: ['', Validators.required]
    });
    this.columns = [
      {
        name: 'countryName',
        displayed: true,
        translationKey: 'df-management.df-admin.table.country-name',
        template: this.countryNameColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'countryCode',
        displayed: true,
        translationKey: 'df-management.df-admin.table.country-code',
        template: this.countryCodeColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'timezone',
        displayed: true,
        translationKey: 'df-management.df-admin.table.time-zone',
        template: this.timeZoneColumn,
        sortable: true,
        alignRight: false,
        alignCenter: true,
      },
      {
        name: 'fixedChargesFrequency',
        displayed: true,
        translationKey: 'df-management.df-admin.table.fixed-charges-frequency',
        template: this.fixedChargesFrequencyColumn,
        sortable: true,
        alignRight: false,
        alignCenter: true,
      },
      {
        name: 'variableCharges',
        displayed: true,
        translationKey: 'df-management.df-admin.table.variable-charges',
        template: this.variableChargesColumn,
        sortable: true,
        alignRight: false,
        alignCenter: true,
      },
      {
        name: 'actions',
        displayed: true,
        translationKey: 'df-management.df-admin.table.actions',
        template: this.actionsColumn,
        sortable: false,
        alignCenter: true,
      }
    ];
    this.sortColumn = this.columns.find((col: DataTableColumn) => col.name === 'timezone');
    this.getAllCountries();
    this.getVariableChargesByCountry()
  }

  goBackAdmin() {
    this.navigationService.dfAdminManagemnt().list().go();
  }

  getAllCountries() {
    this.loader.startLoad();
    this.dfManagementService.getAllCountry()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((country: DFAdmin[]) => {
        this.countryList = country['data']
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-country')
        );
      });
  }

  addVariableCharge() {
    const newCharge = {
      charge_code: this.variableChargesDataForm.value.variableChargeName,
      description: this.variableChargesDataForm.value.description,
      status: 'Y'
    };

    if (this.variableChargesDataForm.valid) {
     const body = {
        charge: newCharge,
        country_code: this.editChargesData['country_code']
      };

      this.dfManagementService.checkDuplicateVariableCharges(body)
        .pipe(finalize(() => this.loader.stopLoad()))
        .subscribe((result: DFAdmin) => {
          if (result['error'] === true) {
            this.toastr.error(result['data']['messages'][0]);
            this.variableChargesDataForm.controls['variableChargeName'].reset();
            this.variableChargesDataForm.controls['description'].reset();
          } else {
            const isDuplicate = this.variableChargesList.some(charge => charge.charge_code === newCharge.charge_code);
            if (!isDuplicate) {
              this.variableChargesList.push(newCharge);
              this.toastr.success(result['data']);
            } else {
              this.toastr.error(this.translate.instant('df-management.df-admin.errors.error-message'));
            }
            this.variableChargesDataForm.controls['variableChargeName'].reset();
            this.variableChargesDataForm.controls['description'].reset();
          }
          this.variableChargeAdded = true;
        }, (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message || this.translate.instant('df-management.table.error-post-data'));
        });
    }
  }


  isSubmitButtonEnabled(): boolean {
    return this.isEditMode && this.variableChargeAdded;
  }

  getVariableChargesByCountry() {
    this.dfManagementService.getVariableChargesByCountry()
  }

  setExistingHeaders(chargesList: DFChargeList[]): FormArray {
    const formArray = new FormArray([]);
    chargesList?.forEach((d: any, i) => {
      formArray.push(
        this.fb.group({
          id: new FormControl(d.id),
          description: new FormControl(d.description),
          chargeCode: new FormControl(d.chargeCode),
          status: new FormControl(d.charge_type)
        })
      );
    });
    return formArray;
  }

    onEditEvent(item: DFAdmin) {
      this.isVisible = !this.isVisible;
      this.editChargesData = item;
      this.variableChargesDataForm.controls['countryCode'].patchValue(item['country_code']);
      this.variableChargesDataForm.controls['countryName'].patchValue(item.country);
      this.variableChargesDataForm.controls['timezone'].patchValue(item['timezone']);

    this.dfManagementService.getVariableChargesByCountry()

      if (item.chargeList?.length) {
        this.variableChargesDataForm.setControl(
          'amount',
          this.setExistingHeaders(item.chargeList)
        );
      }
    }

getVariableChargesList(country: DFAdmin): string {
  this.dfManagementService.getVariableChargesByCountry()
  if (country && country['variableChargeFlag']) {
      const variableChargesList = this.variableChargesList.map(charge => charge['charge_code']);
      return variableChargesList.join(', ');
  } else if (country && country['charge_list'].length && country['charge_list'].length > 0) {
    const variableChargesList = country['charge_list'].map(charge => charge['charge_code']);
        return variableChargesList.join(', ');
  } else {
      return '';
  }
}

  enableEditMode() {
      this.isEditMode = true;
      if (!this.variableChargesList) {
        this.variableChargesList = [];
      }
  }

  disableEditMode() {
      this.isEditMode = false;
  }

  confirmData() {
    this.isPopupModel = false;
    this.getAllCountries();
  }

  updateCountry() {
    this.loader.startLoad();
}
  onCloseEvent() {
    this.variableChargesDataForm.reset()
    this.isVisible = false;
    this.disableEditMode();
    this.variableChargesList = [];
  }

  dfVariableChargesData() {
      this.loader.stopLoad();
      let body ;
      body = {
        charge_list: this.variableChargesList,
        country_code: this.editChargesData['country_code']

      }
      this.dfManagementService.addVariableChargesByCountry(body)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((succeed: DFAdmin) => {
        this.isPopupModel = true;
        this.variableChargesList = [];
        this.isVisible = false
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error.error.message || this.translate.instant('df-management.table.error-post-data'));
      });
    }
}
